<script>
    import menu from '$lib/json/menu.json';
    import { page } from '$app/stores';
	import './styles.css';
	import TransitionBackground from '$lib/components/TransitionBackground.svelte';
	import Button from "$lib/components/Button.svelte";
	import Buy from './Buy.svelte';
	import Logo from '$lib/components/Logo.svelte';
	import SocialList from '$lib/components/SocialList.svelte';

    import { fade } from 'svelte/transition';
	import { afterNavigate, beforeNavigate } from '$app/navigation';
	import { buyVisible, loading, menuOpen } from './states';

    // let buyVisible = false;

    // function handleBuyClick(){
    //     buyVisible = true;
    // }
    
    beforeNavigate(()=>{
        loading.set(true);
        const timeout = setTimeout(()=>{
            if($loading == true){
                loading.set(false);
                clearTimeout(timeout);
            }
        }, 1000);
    });
    afterNavigate(()=>{
        loading.set(false);
    });
    // import { onMount } from 'svelte'
    // import { pwaInfo } from 'virtual:pwa-info'
    // onMount(async () => {
    //     if (typeof window !== 'undefined'){
    //         if (pwaInfo) {
    //             const { registerSW } = await import('virtual:pwa-register')
    //             registerSW({
    //                 immediate: true,
    //                 onRegistered(r) {
    //                     // uncomment following code if you want check for updates
    //                     r && setInterval(() => {
    //                     console.log('Checking for sw update')
    //                     r.update()
    //                     }, 20000 /* 20s for testing purposes */)
    //                     console.log(`SW Registered: ${r}`)
    //                 },
    //             // onRegisterError(error) {
    //                 // console.log('SW registration error', error)
    //             // }
    //             })
    //         }
    //     }
    // })
    $: if($buyVisible) menuOpen.set(false);
</script>

<svelte:head>
    <link rel="manifest" href="/mainfest.json" crossorigin="use-credentials" />
    
    <!-- <link rel="manifest" href={manifest} crossorigin="use-credentials" /> -->
    <!-- {@html webManifestLink} -->
</svelte:head>

<!-- data-page={$page.url.pathname.slice(1,-1)} -->
<div class="app" class:buyVisible={$buyVisible} class:loading={$loading}>
    <header class="header">
        <div class="nav__wrap">
                <Logo on:click={()=>{menuOpen.set(false)}}/>
                <button class="header__burger" class:menuOpen={$menuOpen} on:click={()=>{menuOpen.set(!$menuOpen)}}>
                    {#if $menuOpen}
                        <svg
                            in:fade={{delay:250, duration:120}}
                            out:fade={{delay:0, duration:120}}
                            class="popup__close__icon" xmlns="http://www.w3.org/2000/svg" 
                            viewBox="0 0 24 24" fill="none"
                        >
                            <path fill="currentColor" d="M23.3 3.5v-.2c0-.2 0-.5-.2-.7l.2.9Zm0 0 .1.1v.7a22 22 0 0 1-3.8 5l-3 3L15 14l-.4.3.4.4 4.7 5c.5.6.4 1.4-.2 1.8l-.2.1v.1c-.3.5-.7.7-1 .7h-.4c-.3.3-.7.4-1 .2-1.9-.9-3.7-2.5-5.4-4.2L11 18l-.3.3C9 20.1 7 21.7 5.2 22.1H4.8l-.1-.1c-1-.7-1.5-1.2-1.7-1.7-.2-.5-.3-.9 0-1.3 0-.5.5-1 1-1.5l2-1.7.1-.2.7-.6.2-.2.5-.4-.4-.4L6 13l-2.6-2.3A17 17 0 0 1 .6 7.1a.8.8 0 0 1 0-.8c.4-.7 1-1.1 1.6-1.4l.1-.1.1-.1a1 1 0 0 1 1.7-.3L5.8 6l5.1 4.7.4.3.3-.3c3-2.9 6-5.9 8.8-9 .4-.4 1-.4 1.6 0l1 1 .3.8ZM4.7 22Zm.1 0Z"/>
                        </svg>
                    {:else}
                        <svg
                            in:fade={{delay:250, duration:120}}
                            out:fade={{delay:0, duration:120}}
                            xmlns="http://www.w3.org/2000/svg"  
                            viewBox="0 0 24 24" fill="none"
                        >
                            <path fill="currentColor" fill-rule="evenodd" stroke="currentColor" stroke-linejoin="round" d="M10.3 18h10.4c.3 0 .8.1.8.7v1.4c-.4.1-1 .4-.8.7.3.3-5.6.4-10 .4l-4 .3-4.6-1v-2.2h5l3.2-.3ZM10.3 10.7h10.4c.3 0 .8.1.8.7v1.4c-.4.1-1 .4-.8.7.3.3-5.6.3-10 .3l-4 .4-4.6-1V11h5l3.2-.3ZM10.3 3.3h10.4c.3 0 .8.2.8.7v1.4c-.4.2-1 .5-.8.8.3.2-5.6.3-10 .3l-4 .4-4.6-1.1V3.7h5l3.2-.4Z" clip-rule="evenodd"/>
                        </svg>
                    {/if}
                </button>
                <nav class="header__menu" class:menuOpen={$menuOpen}>
                    {#each menu.header as {label, link}}
                        <a href={link} class:active={$page.url.pathname == link} on:click={()=>{menuOpen.set(false)}}>{label}</a>
                    {/each}
                    <Button tag="button" styleType="border" on:click={()=>{buyVisible.set(true)}}>
                        Купить
                    </Button>
                </nav>
            </div>
    </header>
    {#if $loading}
        <div class="preloader" in:fade={{duration: 150, delay: 300}} out:fade={{duration: 150}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="80px" height="80px" viewBox="0 0 128 128" class="svelte-mskttf">
                <path fill="var(--color-text)" d="M64.4 16a49 49 0 0 0-50 48 51 51 0 0 0 50 52.2 53 53 0 0 0 54-52c-.7-48-45-55.7-45-55.7s45.3 3.8 49 55.6c.8 32-24.8 59.5-58 60.2-33 .8-61.4-25.7-62-60C1.3 29.8 28.8.6 64.3 0c0 0 8.5 0 8.7 8.4 0 8-8.6 7.6-8.6 7.6z"></path>
            </svg>
        </div>
    {/if}
	<main>
		<slot />
	</main>
    <footer class="footer">
        {#if $page.url.pathname == '/contacts/'}
            <svg class="footer__imgFish" xmlns="http://www.w3.org/2000/svg" width="310" height="282" viewBox="0 0 310 282" fill="none">
                <path fill="url(#a)" d="m258 135-22-7 2-3 19-1c13-12 25-21 35-24l-1-5c-8-28-25-48-49-61-10-10-19-18-29-25 41 14 72 40 88 85l6 5 2 4-13 18-4-2 5-10c-16 3-40 23-39 26m-98-75c1 13 3 26 8 38 28 23 58 39 92 43 14 6 34 7 33-13l3-1 3 12-3 5-18 10c-52-4-89-24-121-51-3-13 0-28 3-43Zm-41 62c14-2 30-2 49 2l33 19c-36 3-74 25-90 60-1-15-1-29 4-42-35-4-61 20-60 37l-7-7c2-22 35-47 77-42-3 8-4 15-4 22 12-19 34-29 47-33-10-8-29-12-49-16Zm-12 102s-52 5-80-28a75 75 0 0 1-19-50C5 87 54 40 107 17c-25-6-51 3-76 13C92-15 190-7 244 47c-87-67-208-1-224 78-3 15-2 30 3 44 6 14 18 31 39 40 25 11 49 9 69 11l-8 6c-35 24-60 23-60 23-10 17-15 33-15 33v-1 1C2 230 0 166 0 166c13 59 42 84 42 84 7-11 8-22 8-22 28 11 56-4 57-4ZM234 96c5 12-11 16-19 6 1-3-6-6-14-11 11 1 22 1 33 5Z"/>
                <defs>
                <linearGradient id="a" x1="265.2" x2="140.1" y1="3.1" y2="334.6" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#14342B"/>
                    <stop offset="1" stop-color="#14342B" stop-opacity="0"/>
                </linearGradient>
                </defs>
            </svg>  
        {/if}
        <div class="footer__transition">
            <TransitionBackground color="var(--color-text)" bgColor="var(--color-bg-0)" reverseImage={true}/>
        </div>
        <div class="footer__nav">
            <div class="nav__wrap">
                <div class="footer__col">
                    <Logo />
                </div>
                <div class="footer__col">
                    <span class="copyright">
                        © probaits, 2023
                    </span>
                </div>
                <div class="footer__col">
                    <SocialList />
                </div>
            </div>
        </div>
    </footer>
    <Buy/>
</div>
